"use strict";

angular.module("vendor")
.service("VendorPaymentService", function(
    $resource, FlashBag, gettextCatalog, PaymentSelectorUnregisteredServiceFactory, common, appConfig
) {
    const LISTING_URL = "/invoice/vendor/payments/list/";

    function VendorPaymentService() {
        PaymentSelectorUnregisteredServiceFactory.call(this, LISTING_URL);

        this.getBulkActionParams = function() {
            return {};
        };

        this.getSingleActionParams = function() {
            return this.getBulkActionParams();
        };

        this.exportData = function(params) {
            var exportResource = $resource(appConfig.API_SERVER + "/invoice/vendor/payments/export/", {}, {
                get: {
                    method: "GET",
                    isArray: false,
                    interceptor: {responseError: FlashBag.responseErrorInterceptor}
                }
            });
            return exportResource.get(params).$promise.then(function(data) {
                var file_data = data.file_data;
                if (file_data) {
                    common.downloadExcelFile(file_data, data.file_name);
                }
                else {
                    FlashBag.preformattedError(gettextCatalog.getString("There was an error while generating the file. Please try again."));
                }
            })
        }
    }

    return new VendorPaymentService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/payment/vendor-payment.service.js
// module id = 890
// module chunks = 0